export default {
	'financial-organ-manage': {
		id: 'financial-organ-manage',
		label: '机构管理',
		code: '0007_0006_0002',
		child: {
			'edit-organ': {
				id: 'edit-organ',
				label: '编辑',
				code: '0007_0006_0002_002_001'
			},
			'enable-organ': {
				id: 'enable-organ',
				label: '启用',
				code: '0007_0006_0002_006_001'
			},
			'disable-organ': {
				id: 'disable-organ',
				label: '停用',
				code: '0007_0006_0002_008_001'
			},
			'export-organ': {
				id: 'export-organ',
				label: '导出',
				code: '0007_0006_0002_040_001'
			},
			'import-organ': {
				id: 'import-organ',
				label: '批量导入',
				code: '0007_0006_0002_030_006'
			}
		}
	}
}
